import KeyPager from 'app/shared/model/KeyPager';

const Listing = ({
    aliasEncoded = '',
    city = '',
    country = '',
    listingId = '',
    message = '',
    primaryPhotoUrl = '',
    priority = '',
    state = '',
    street = '',
    unit = '',
    urlPath = '',
    zip = '',
} = {}) => ({
    aliasEncoded: String(aliasEncoded),
    city: String(city),
    country: String(country),
    listingId: String(listingId),
    message: String(message),
    primaryPhotoUrl: String(primaryPhotoUrl),
    priority: String(priority),
    state: String(state),
    street: String(street),
    unit: String(unit),
    urlPath: String(urlPath),
    zip: String(zip),
});

const ListingInt = ({
    isPartialResponse = false,
    listings = [],
    numTotalListings = 0,
    pager = {},
} = {}) => ({
    isPartialResponse: String(isPartialResponse),
    listings: listings.map(item => Listing(item)),
    numTotalListings: Number(numTotalListings),
    pager: KeyPager(pager),
});

export default ListingInt;
